/**
 * The MCP Apps `ui/download-file` request, as Upright's chat answers it (PLT-7593).
 *
 * A card cannot reach the network, so to save a file it hands the host a `resource_link` and the
 * host fetches it with the user's session. That makes the host a request the card can steer, so
 * it fetches only the chat's own PDF exports, by an exact path shape: a card that asked for any
 * other URL, API route or method gets an error instead of an authenticated request made for it.
 */

/** `/api` + this is the export route in `upserve/modules/chat/investor-report-pdf.ts`. */
const PDF_EXPORT_PATH =
  /^\/chat\/conversations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/investor-report-pdf\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const DEFAULT_FILE_NAME = 'Upright report.pdf';

export interface McpAppDownload {
  /** API path under `/api`, for the platform fetcher. */
  path: string;
  fileName: string;
}

/** The export a `ui/download-file` request names, or `null` for anything the host does not fetch. */
export function parseMcpAppDownloadRequest(params: unknown): McpAppDownload | null {
  if (params === null || typeof params !== 'object') return null;
  const { contents } = params as { contents?: unknown };
  if (!Array.isArray(contents) || contents.length !== 1) return null;
  const link = contents[0] as { type?: unknown; uri?: unknown; name?: unknown } | null;
  if (link?.type !== 'resource_link' || typeof link.uri !== 'string' || !PDF_EXPORT_PATH.test(link.uri)) {
    return null;
  }
  const name = typeof link.name === 'string' ? link.name.replace(/[/\\]/g, ' ').trim() : '';
  const fileName = name === '' ? DEFAULT_FILE_NAME : name.toLowerCase().endsWith('.pdf') ? name : `${name}.pdf`;
  return { path: link.uri, fileName };
}
